import { Injectable } from '@angular/core';
import { LineOption } from '@app/customers-base';
import { GenericService } from '@messaia/cdk';
import { Observable } from 'rxjs';
import { Profile } from '../models/profile';

@Injectable({ providedIn: 'root' })
export class ProfileService extends GenericService<Profile> {

	/**
	 * Constructor
	 */
	constructor() {
		super('customer');
	}

	/**
	 * Changes user's password
	 * @param @param entity The entity to update 
	 */
	public changePassword(entity: any): Observable<any> {
		return super.create(entity, '/changePassword');
	}

	/**
	 * Updates the line option
	 * @param id 
	 * @param connectionId 
	 * @param lineOption 
	 * @returns 
	 */
	public updateLineOption(id: number, connectionId: number, lineOption: LineOption): Observable<any> {
		return super.update(`updateLineOption/${id}/connection/${connectionId}`, lineOption, null, { headers: { 'Show-Message': 'Yes' } });
	}
}